import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { ChevronDown, ChevronUp } from "@/icons/outlined";

interface RateExtrasToggleProps {
  isOpen: boolean;
  onToggle: () => void;
  closedLabel?: string;
  openLabel?: string;
  variant?: "text" | "outlined";
}

export const RateExtrasToggle: FC<RateExtrasToggleProps> = ({
  isOpen,
  onToggle,
  closedLabel,
  openLabel,
  variant = "text",
}) => {
  const { t } = useTranslate();

  return (
    <DashboardButton
      variant={variant}
      vibe="neutral"
      size="small"
      endIcon={isOpen ? <ChevronUp /> : <ChevronDown />}
      onClick={onToggle}
      data-test="rate-extras-toggle"
    >
      {isOpen
        ? (openLabel ?? t("dashboard", "ticketing.rateOptionLess"))
        : (closedLabel ?? t("dashboard", "ticketing.rateOptionMore"))}
    </DashboardButton>
  );
};
